import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://e1767a2a62f447d977b8c1a9002325b1@o553797.ingest.sentry.io/4506753981087744",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});